export const scrollWindow = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};
